var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50064 8.49572L10.1996 12.2829C10.5706 12.6657 10.8121 12.6696 11.1899 12.2829L11.9321 11.5229C12.2956 11.1507 12.3203 10.9064 11.9321 10.5089L8.016 6.5L11.9324 2.49108C12.2992 2.11429 12.3064 1.86 11.9324 1.47679L11.1903 0.717147C10.8053 0.322861 10.5674 0.341076 10.1999 0.717147L6.50064 4.50429L2.80171 0.717504C2.43421 0.341433 2.19636 0.323218 1.81136 0.717504L1.06921 1.47715C0.694927 1.86036 0.701713 2.11465 1.06921 2.49143L4.98528 6.5L1.06921 10.5089C0.680998 10.9064 0.701713 11.1507 1.06921 11.5229L1.811 12.2829C2.18564 12.6696 2.42707 12.6657 2.80136 12.2829L6.50064 8.49572Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.bd671a72260edc962cce0e1e0f7b92ab.svg";
export { ForwardRef as ReactComponent };